import {
    FETCH_DOCUMENT_USERS,
    FETCH_DOCUMENT_USERS_SUCCESS,
    FETCH_DOCUMENT_USERS_FAILED,
    UPDATE_DOCUMENT_USERS,
} from "../store/types";

const initialState = {
    data: [],
    loading: false,
    error: null,
};

export const documentUsersReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_DOCUMENT_USERS:
            return {
                ...state,
                loading: true,
            };
        case FETCH_DOCUMENT_USERS_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
            };
        case UPDATE_DOCUMENT_USERS:
            console.log(
                "🔄 Reducer: Updating document user in local state:",
                action.payload?.id
            );
            console.log("🔄 Reducer: Received payload:", {
                id: action.payload?.id,
                approved: action.payload?.approved,
                files: action.payload?.files,
                new_files: action.payload?.new_files,
                files_type: typeof action.payload?.files,
                files_length: action.payload?.files
                    ? Array.isArray(action.payload.files)
                        ? action.payload.files.length
                        : Object.keys(action.payload.files).length
                    : 0,
            });
            console.log(
                "🔄 Reducer: Full payload structure:",
                JSON.stringify(action.payload, null, 2)
            );

            if (!state.data || !action.payload?.id) {
                console.log(
                    "🔄 Reducer: No data to update, returning current state"
                );
                return state;
            }

            // Update the specific document in the data object
            const updatedData = {
                ...state.data,
                [action.payload.id]: action.payload,
            };

            console.log(
                "🔄 Reducer: Updated data keys:",
                Object.keys(updatedData)
            );
            console.log(
                "🔄 Reducer: Updated document files:",
                updatedData[action.payload.id]?.files
            );

            return {
                ...state,
                data: updatedData,
            };
        case FETCH_DOCUMENT_USERS_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

export default documentUsersReducer;
